











































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IUser } from "@/models/users";

import UserProvider from "@/components/app/admin/users/userProvider.vue";

@Component({
  components: {
    "user-provider": UserProvider
  }
})
export default class AdminUserView extends Vue {
  // Refs

  public declare $refs: {
    userProvider: UserProvider;
  };

  // Props

  @Prop({ required: true })
  public userId!: IUser["id"];

  // Life-cycle methods

  public mounted() {
    this.$bus.$emit("scrollToTop");
  }

  // Computed

  public get routes(): any[] {
    return this.$_.get(this, "$attrs.routes", () => [])({
      isApiToken: this.$refs.userProvider.user.api_user
    });
  }
}
